import { useState, useEffect } from 'react';

type useDeviceWidthType = {
  width: number | null;
  height: number | null;
};

const useDeviceSize = (): useDeviceWidthType => {
  const isClient = typeof window === 'object';

  function getWindowSize(): useDeviceWidthType {
    return {
      width: isClient ? window.innerWidth : null,
      height: isClient ? window.innerHeight : null
    };
  }

  const [windowSize, setWindowSize] = useState<useDeviceWidthType>(getWindowSize);

  useEffect(() => {
    if (!isClient) return;

    const handleResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClient]);

  return windowSize;
};

export default useDeviceSize;
